import Loan from './models/Loan';
import CreditCard from './models/CreditCard';
import Mortgage from './models/Mortgage';
import CorporateLoan from './models/CorporateLoan';
import GamblingOperator from './models/GamblingOperator';

function app({ app }, inject) {
    const models = {
        CreditCard: CreditCard,
        Loan: Loan,
        Mortgage: Mortgage,
        CorporateLoan: CorporateLoan,
        GamblingOperator: GamblingOperator
    };

    app.context.$models = models;
    inject('models', models);
}

export default app;
export { Loan, CreditCard, Mortgage, CorporateLoan, GamblingOperator };